import grpcClient from '~/grpc/grpc-client'
import { commonMetaData } from '@/store/_helpers/common-helper'

// initial state
const initialState = () => ({
  id: null,
  profileId: null,
  description: null,
  priceGroupsList: []
})

// state
export const state = () => initialState()

// getters
export const getters = {
  daysToDeliveryText: (state, getters, globalState) => daysToDelivery => {
    if (daysToDelivery === globalState.master.daysToDeliveriesNeedConsultation) {
      return '要相談'
    }
    return daysToDelivery + '日'
  }
}

const sort = price => {
  if (!price || price.priceGroupsList.length === 0) return price

  price.priceGroupsList.sort((a, b) => {
    if (a.position < b.position) {
      return -1
    } else if (a.position > b.position) {
      return 1
    } else {
      return 0
    }
  })

  return price
}

// actions
export const actions = {
  async fetchPrice({ commit, rootState }, userId) {
    const [{ GetPricesRequest }, { PriceService }] = await Promise.all([
      import('~/stub/apigateway/profile/price_pb'),
      import('~/stub/apigateway/profile/price_pb_service')
    ])

    const metadata = commonMetaData(rootState)
    const request = new GetPricesRequest()
    request.setUserId(userId)
    const response = await grpcClient({
      method: PriceService.GetPrices,
      request,
      metadata
    })
    response.price = sort(response.price)
    commit('RECEIVE_PRICE', response)
  }
}

// mutations
export const mutations = {
  RESET(state) {
    Object.assign(state, initialState())
  },
  RECEIVE_PRICE(state, data) {
    Object.assign(state, data.price)
  }
}
